import { Component, OnInit } from '@angular/core';

import { CensoService } from '@app/shared/services/censo.service';

import { Censo } from '@app/shared/models';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-header-public-page',
  templateUrl: './header-public-page.component.html',
  styleUrls: ['./header-public-page.component.scss']
})
export class HeaderPublicPageComponent implements OnInit {

  censo: Censo;
  cliente = environment.cliente;

  constructor(private censoService: CensoService) { }

  ngOnInit(): void {
    this.censo = this.censoService.retornarSessionStorage('censo');
  }

}
